export function bindAmountPasteGuard(inputEl) {
    if (!inputEl || inputEl.dataset.amountPasteGuardBound === "true") return;

    inputEl.dataset.amountPasteGuardBound = "true";

    const block = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    inputEl.addEventListener("paste", block, true);
    inputEl.addEventListener("drop", block, true);
    inputEl.addEventListener("beforeinput", (event) => {
        if (event.inputType === "insertFromPaste" || event.inputType === "insertFromDrop") {
            block(event);
        }
    }, true);
    inputEl.addEventListener("keydown", (event) => {
        const isPasteShortcut = (event.ctrlKey || event.metaKey) && event.key?.toLowerCase?.() === "v";
        const isShiftInsert = event.shiftKey && event.key === "Insert";
        if (isPasteShortcut || isShiftInsert) {
            block(event);
        }
    }, true);
}
